import { v4 as uuid } from 'uuid';
import type { ScheduleGroup } from '../types/schedule-groups';
import type { School } from '../types/schools';
import type { OutTypes } from './schedules';


export default function (
  scheduledGroups: ScheduleGroup[] | undefined,
  school:          School,
  courseMap:       Map<number, OutTypes.course[]>,
  importErrors:    string[],
  importWarnings:  string[],
): OutTypes.course[] {

  const courses: OutTypes.course[] = [];

  scheduledGroups?.forEach(scheduledGroup => {

    ////
    //// check number of subjects/courses
    ////
    const subjects = school.school_type == 'GR' ? scheduledGroup.subjects : scheduledGroup.courses;
    // Nikos takes full responsibility for this line of code and the decision to allow multiple subjects per schedule group, which is a scenario that we have observed in the wild but that we do not fully understand the implications of.
    for (const subject of subjects) {
      ////
      //// check number of teachers
      ////
      if (scheduledGroup.teachers?.length == 0) {
        const warn = `The schedule group "${scheduledGroup.name}" with id "${scheduledGroup.id}" did not contain any teachers.`;
        importWarnings.push(warn);
      }

      const id = scheduledGroup.id;
      // generate a uuid since admentum id is degenerate now when we have multiple subjects per schedule group
      const ids = uuid();
      if (!courseMap.has(id)) {
        courseMap.set(id, []);
      }

      const course ={
        ids,
        displayName: scheduledGroup.name,
        subject:     subject.name,
        groups:      scheduledGroup.users_primary_groups.map(x => ({ to: x.toString() })),
        teachers:    scheduledGroup.teachers?.map(x => ({ to: x.id.toString() }))
      } satisfies OutTypes.course;

      courseMap.get(id)?.push(course);

      courses.push(course);
    }
  });

  return courses;
}
